
import { FirearmEntityDecorator } from './firearm.decorator';
import { Firearm } from './firearm.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmTypeInfoBase implements CrudTypeInfo<Firearm, number> {
  name = 'Firearm';
  entityDecorator = new FirearmEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM'];
  editAuthorities = ['WRITE_FIREARM'];
  deleteAuthorities = ['DELETE_FIREARM'];
  viewAuthorities = ['READ_FIREARM'];
  
  searchRouteBase = ['/firearm/search'];
  createRouteBase = ['/firearm/create'];
  editRouteBase = ['/firearm/edit'];
  viewRouteBase = ['/firearm/view'];
  
  description(item: Firearm): string {
    return '' +  item.assetId;
  }
}



